
import _ from 'underscore';
import {
    defineComponent, PropType, computed, toRefs, unref,
} from '@vue/composition-api';
import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
import ToggleListContent from '@ve/components/filters/common/components/toggleListContent/ToggleListContent.vue';
import { SerpHotelAdapted } from '@ve/components/searchFilters/store/types';
import FilterAttributeMethods from '@ve/components/filters/common/filterMethods/filterAttributeMethods/FilterAttributeMethods';
import FilterListRender from '@ve/components/filters/common/components/FilterListRender/FilterListRender.vue';
import { IAttributeHotel } from '@ve/components/filters/common/filterMethods/filterAttributeHotelMethods';

export default defineComponent({
    name: 'AtributesHotelFilter',
    components: {
        FiltersListSection,
        ToggleListContent,
        FilterListRender,
    },
    model: {
        prop: 'selectedAttributes',
        event: 'change',
    },
    props: {
        filterAttributeHotelMethods: {
            type: Object as PropType<FilterAttributeMethods<IAttributeHotel, boolean>>,
            required: true,
        },
        selectedAttributes: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
        filteredHotels: {
            type: Array as PropType<SerpHotelAdapted[]>,
            default: () => [],
        },
        allHotels: {
            type: Array as PropType<SerpHotelAdapted[]>,
            default: () => [],
        },
        visibleCounter: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, { emit }) {
        const { selectedAttributes, allHotels } = toRefs(props);
        const { filterAttributeHotelMethods } = props;
        const selectedAttribute = computed({
            get: () => unref(selectedAttributes),
            set: (values: number[]) => {
                emit('change', values);
            },
        });
        const isOneHotelHasAttributes = computed(() => filterAttributeHotelMethods.getIsOneHotelHasProperty(unref(allHotels)));

        return {
            selectedAttribute,
            isOneHotelHasAttributes,
        };
    },
});
